const KNOWN_STATUS_CODES = new Set([
  "VERIFIED",
  "REVOKED",
  "EXPIRED",
  "NOT_VERIFIED",
]);

export const normalizePublicVerificationStatusCode = (result) => {
  const raw =
    result?.status_code || result?.status || result?.verification_status;
  if (!raw || typeof raw !== "string") return null;

  const normalized = raw.trim().toUpperCase().replace(/\s+/g, "_");
  if (KNOWN_STATUS_CODES.has(normalized)) return normalized;

  if (/^revoked$/i.test(raw) || /revok/i.test(raw)) return "REVOKED";
  if (/^expired$/i.test(raw) || /expir/i.test(raw)) return "EXPIRED";
  if (/reject|fail|invalid|not[_\s-]?verif|unverif/i.test(raw)) {
    return "NOT_VERIFIED";
  }
  if (
    /^approved$/i.test(raw) ||
    /^verified$/i.test(raw) ||
    /^credential[_\s-]?verified$/i.test(raw)
  ) {
    return "VERIFIED";
  }

  return null;
};

export const getPublicVerificationStatusLabel = (result, t) => {
  const statusCode = normalizePublicVerificationStatusCode(result);
  if (!statusCode) {
    return (
      result?.status || t("publicPortal:verification.statusLabels.NOT_VERIFIED")
    );
  }
  return t(`publicPortal:verification.statusLabels.${statusCode}`);
};

export const getPublicVerificationStatusMessage = (result, t) => {
  const statusCode = normalizePublicVerificationStatusCode(result);
  if (!statusCode) {
    return t("publicPortal:verification.statusMessages.NOT_VERIFIED");
  }
  return t(`publicPortal:verification.statusMessages.${statusCode}`);
};

export const getPublicVerificationStatusVisualKey = (result) => {
  const statusCode = normalizePublicVerificationStatusCode(result);
  switch (statusCode) {
    case "VERIFIED":
      return "approved";
    case "REVOKED":
      return "revoked";
    case "EXPIRED":
      return "expired";
    case "NOT_VERIFIED":
    default:
      return "rejected";
  }
};
